import { InfoTipoScommessa, SizeInfoAggiuntiva } from 'lib/api/sport/sportScommesseBySlugResponse';

import { isSnaiSite } from 'utility/constant';
import { sortInfoTipoHeaders } from 'features/sport/utils/utils';

export const esito = isSnaiSite ? 'esito' : 'result';
export const esitoTrKey = 'generic-result';

export const calculateBoxNumber = (infoTipoScommessa?: InfoTipoScommessa, trKey: string = esitoTrKey) => {
  if (!infoTipoScommessa) return [];

  const {
    headers,
    isAntepost,
    numeroEsiti,
    headersTrKey,
    sizeInfoAggiuntive,
    headersInfoAggiuntive,
    headersInfoAggiuntiveTrKey,
  } = sortInfoTipoHeaders(infoTipoScommessa);

  const boxesInfoAgg = (headersInfoAggiuntive ?? []).map((header, index) => {
    return {
      header,
      headerTrKey: headersInfoAggiuntiveTrKey?.[index],
      size: (sizeInfoAggiuntive && sizeInfoAggiuntive[index]) || SizeInfoAggiuntiva.Small,
      isInfoAgg: true,
    };
  });

  const boxesEsito = (numeroEsiti > 3 || !isAntepost ? headers.slice(0, 3) : headers).map((header, index) => {
    return {
      header: numeroEsiti > 3 ? esito : header,
      headerTrKey: numeroEsiti > 3 ? trKey : headersTrKey?.[index],
      size: SizeInfoAggiuntiva.Small,
      isInfoAgg: false,
    };
  });

  return [...boxesInfoAgg, ...boxesEsito];
};
